/**
 * Feedback form config. All values are public:
 *  - `turnstileSiteKey` is rendered into the widget's data-sitekey and
 *    is not a secret;
 *  - `feedbackEndpoint` is the public URL of the `feedback-proxy` Worker —
 *    it is CORS-locked and captcha-gated, so it is also fine to ship
 *    in the bundle;
 *  - `uploadEndpoint` is the sibling URL that accepts a single multipart
 *    attachment and returns `{ ref }`. Worker support for this route is
 *    tracked in a separate ticket; until it lands, attachment uploads
 *    will fail and the form surfaces the error in the status line.
 *
 * Secrets (Turnstile secret, Resend API key) live as Worker secrets;
 * see `worker/README.md`.
 */
export interface IFeedbackFormConfig {
    readonly turnstileSiteKey: string;
    readonly feedbackEndpoint: string;
    readonly uploadEndpoint: string;
}

export const feedbackFormConfig: IFeedbackFormConfig = {
    turnstileSiteKey: '0x4AAAAAADAZjAhnxytjRtI2',
    feedbackEndpoint: 'https://feedback-proxy.staircraftdesigne.workers.dev',
    uploadEndpoint: 'https://feedback-proxy.staircraftdesigne.workers.dev/upload',
};
